module.exports = function () {
  "use strict";

  var t = {
    210: function _(t, n, e) {
      function o(t, n, e) {
        return e ? n ? n(t) : t : (t && t.then || (t = Promise.resolve(t)), n ? t.then(n) : t);
      }

      function r(t) {
        return function () {
          for (var n = [], e = 0; e < arguments.length; e++) {
            n[e] = arguments[e];
          }

          try {
            return Promise.resolve(t.apply(this, n));
          } catch (t) {
            return Promise.reject(t);
          }
        };
      }

      e.r(n), e.d(n, {
        beginMultipartUpload: function beginMultipartUpload() {
          return h;
        },
        completeUploadPart: function completeUploadPart() {
          return y;
        },
        getUploadPart: function getUploadPart() {
          return l;
        },
        request: function request() {
          return c;
        }
      });
      var c = r(function (t, n) {
        var e = function (t, n) {
          var e,
              o,
              r = n.path.replace(/[:]/g, "_"),
              c = "".concat(t.BASE).concat(r);
          return n.query ? "".concat(c).concat((e = n.query, o = [], Object.keys(e).forEach(function (t) {
            var n = e[t];
            (function (t) {
              return null != t;
            })(n) && (Array.isArray(n) ? n.forEach(function (n) {
              o.push("".concat(encodeURIComponent(t), "=").concat(encodeURIComponent(String(n))));
            }) : o.push("".concat(encodeURIComponent(t), "=").concat(encodeURIComponent(String(n)))));
          }), o.length > 0 ? "?".concat(o.join("&")) : "")) : c;
        }(t, n);

        return o(a(t, n, e), function (t) {
          var o,
              r,
              c = (r = (o = t).getResponseHeader(s)) ? r.toLowerCase().startsWith(f) ? JSON.parse(o.responseText) : o.responseText : null,
              a = function (t, n) {
            return n ? t.getResponseHeader(n) : null;
          }(t, n.responseHeader);

          return {
            url: e,
            ok: t.status >= 200 && t.status < 300,
            status: t.status,
            statusText: t.statusText,
            body: a || c
          };
        });
      }),
          a = r(function (t, n, e) {
        var r = new XMLHttpRequest();
        return r.open(n.method, e, !0), r.withCredentials = t.WITH_CREDENTIALS, o(u(t, n), function (t) {
          return t.forEach(function (t, n) {
            r.setRequestHeader(n, t);
          }), new Promise(function (t) {
            r.onreadystatechange = function () {
              r.readyState === XMLHttpRequest.DONE && t(r);
            }, r.send(function (t) {
              if (t.body) return JSON.stringify(t.body);
            }(n));
          });
        });
      }),
          u = r(function (t, n) {
        return o(i(n, t.USERNAME), function (e) {
          return o(i(n, t.PASSWORD), function (r) {
            return o(i(n, t.HEADERS), function (t) {
              var o = new Headers(Object.assign(Object.assign({
                Accept: f
              }, t), n.headers));

              if (p(e) && p(r)) {
                var c = btoa("".concat(e, ":").concat(r));
                o.append("Authorization", "Basic ".concat(c));
              }

              return n.body && o.append(s, f), o;
            });
          });
        });
      }),
          i = r(function (t, n) {
        return "function" == typeof n ? n(t) : n;
      }),
          s = "Content-Type",
          f = "application/json";

      function p(t) {
        return "string" == typeof t && "" !== t;
      }

      function d(t) {
        return function () {
          for (var n = [], e = 0; e < arguments.length; e++) {
            n[e] = arguments[e];
          }

          try {
            return Promise.resolve(t.apply(this, n));
          } catch (t) {
            return Promise.reject(t);
          }
        };
      }

      var l = d(function (t, n, e, o) {
        return c(t, {
          method: "GET",
          path: "".concat(g).concat(n).concat(m, "/").concat(e).concat(v).concat(o)
        });
      }),
          y = d(function (t, n, e, o, r) {
        return c(t, {
          method: "PUT",
          path: "".concat(g).concat(n).concat(m, "/").concat(e).concat(v).concat(o),
          body: r
        });
      }),
          h = d(function (t, n, e) {
        return c(t, {
          method: "POST",
          path: "".concat(g).concat(n).concat(m),
          body: e
        });
      }),
          g = "/v2/accounts/",
          m = "/uploads",
          v = "/parts/";
    }
  },
      n = {};

  function e(o) {
    if (n[o]) return n[o].exports;
    var r = n[o] = {
      exports: {}
    };
    return t[o](r, r.exports, e), r.exports;
  }

  return e.d = function (t, n) {
    for (var o in n) {
      e.o(n, o) && !e.o(t, o) && Object.defineProperty(t, o, {
        enumerable: !0,
        get: n[o]
      });
    }
  }, e.o = function (t, n) {
    return Object.prototype.hasOwnProperty.call(t, n);
  }, e.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, e(210);
}();